export const HEADER_HEIGHT = 100;
export const BACK_TO_TOP_ANCHOR = "BACK_TO_TOP_ANCHOR";
